import { useEffect, useMemo, useRef } from "react";
import "./css/AmmountField.css";
import { decode } from "he";

export default function AmmountField({
  id,
  name,
  className,
  label,
  value,
  onChange,
  options,
  valueAttr,
  labelAttr,
  clearLabel,
  isInvalid,
  error,
  help,
  labelStyle,
  disabled,
  unit,
  ...props
}) {
  const inputRef = useRef();
  const handleChange = useMemo(
    () => (event) => {
      if (event.target === inputRef.current) {
        if (onChange instanceof Function) {
          onChange(event);
        }
      } else {
        event.stopPropagation();
      }
    },
    [onChange],
  );
  const handleMagnitudChange = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const magnitud = event.target.value;
    inputRef.current.value = {
      ...(value || {}),
      magnitud,
      unidad: unit,
    };
    inputRef.current.name = name;
    inputRef.current.dispatchEvent(
      new Event("change", { bubbles: true, cancelable: true, composed: false }),
    );
  };
  const computedAmmount =
    !!value?.magnitud || value?.magnitud === 0 ? value?.magnitud : "";
  const computedClassName = [
    "form-group",
    "ammount-field",
    isInvalid ? "has-error" : "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  useEffect(() => {
    const input = inputRef.current;
    const onChange = handleChange;
    if (!!input) {
      input.addEventListener("change", onChange);
      return () => {
        input.removeEventListener("change", onChange);
      };
    }
  }, [handleChange]);
  return (
    <div id={id} className={computedClassName} ref={inputRef} {...props}>
      {!!label && (
        <label for={id} style={labelStyle} className="control-label">
          {label}
        </label>
      )}

      <span className="input-group">
        <input
          id={`${id}_magnitud`}
          name={`${name}.magnitud`}
          className="form-control"
          min={0}
          maxLength={30}
          max={9.99999999999999999999999999999e30}
          type="number"
          value={computedAmmount}
          onChange={handleMagnitudChange}
          aria-invalid={isInvalid}
          disabled={disabled}
        />
        <span className="input-group-addon">
          <label>{!!unit && decode(unit?.html)}</label>
        </span>
      </span>
      {isInvalid && !!error && <span className="help-block">{error}</span>}
    </div>
  );
}

AmmountField.defaultProps = {
  className: "",
};
